import type { Fallacy } from "./types";
import { createStory } from "./types";

export const hastyGeneralization: Fallacy = {
    id: "hasty-generalization",
    name: "Hasty Generalization",
    emoji: "🏃",
    category: "Argumen Lemah",
    description:
      "Membuat **kesimpulan umum** dari **sampel yang terlalu sedikit** atau pengalaman pribadi.",
    detail:
      "Hasty Generalization adalah kesalahan logika di mana seseorang membuat **kesimpulan umum** berdasarkan **sampel yang terlalu kecil** atau satu-dua pengalaman pribadi saja. Dari satu atau sedikit kasus, langsung menyimpulkan bahwa SEMUA seperti itu.\n\nKenapa ini berbahaya? Karena ini adalah **dasar dari stereotip dan prasangka**. Dari generalisasi terburu-buru inilah diskriminasi berawal — menilai seluruh kelompok berdasarkan perilaku beberapa individu.\n\nCara melawan: Tanyakan — berapa besar sampelnya? Apakah representatif? Apakah ada data yang lebih luas?",
    tldr: "Satu kejadian langsung digeneralisasi semua? Datanya mana, bos?",
    story: createStory("Hasty Generalization", "🏃", {
      hook: {
        title: "Satu kejadian buruk...",
        body: "Langsung disimpulkan **SEMUA kayak gitu**. Datanya? Cuma satu pengalaman pribadi.",
      },
      convo: {
        claim: "Temen aku beli HP merk Z satu dan langsung rusak. Merk Z mah **emang sampah semua**, gak usah beli.",
        response: "Itu cuma satu unit. **Gak bisa judge seluruh merk dari satu kasus.**",
      },
      reveal: {
        body: "Bikin **kesimpulan umum** dari **sampel yang terlalu kecil**. Dari satu-dua kasus, langsung bilang SEMUA kayak gitu.",
      },
      insight: {
        title: "Kenapa ini bahaya?",
        body: "Dari sinilah **stereotip dan prasangka** bermula. Satu pengalaman buruk langsung dijadiin patokan buat semuanya — gak fair, gak akurat.",
      },
      engagement: {
        title: "Pernah judge sesuatu cuma dari 1 pengalaman?",
        body: "Merk HP, restoran, atau bahkan orang? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-nature", "bandwagon", "slippery-slope"],
  };
